var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "files",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7074",
    "data-name": "Rectangle 7074",
    width: 11,
    height: 11,
    transform: "translate(-0.001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65001",
    "data-name": "Path 65001",
    d: "M53.214,70.952H48.348A.348.348,0,0,1,48,70.6V64.348A.348.348,0,0,1,48.348,64h3.476l1.738,1.738V70.6A.348.348,0,0,1,53.214,70.952Z",
    transform: "translate(-45.866 -61.412)",
    fill: "none",
    stroke: "#3b86ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65002",
    "data-name": "Path 65002",
    d: "M80,33.39V32.348A.348.348,0,0,1,80.348,32h3.476l1.738,1.738V38.6a.348.348,0,0,1-.348.348H84.171",
    transform: "translate(-76.476 -30.803)",
    fill: "none",
    stroke: "#3b86ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_224",
    "data-name": "Line 224",
    x2: 2,
    transform: "translate(3.999 7)",
    fill: "none",
    stroke: "#3b86ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_225",
    "data-name": "Line 225",
    x2: 2,
    transform: "translate(3.999 8)",
    fill: "none",
    stroke: "#3b86ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.ac2b9f22da85511678b81b338ea0d88e.svg";
export { ForwardRef as ReactComponent };